import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API } from '../../App';
import { toast } from 'sonner';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../ui/table';

const ReadOnlySheet = ({ sheetName }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchData();
  }, [sheetName]);

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${API}/sheets/${sheetName}`);
      setData(response.data.data);
    } catch (error) {
      toast.error(`Failed to load ${sheetName} data`);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="p-6 text-slate-600">Loading...</div>;
  }

  return (
    <div className="bg-white rounded-lg border border-slate-200 shadow-sm fade-in">
      <div className="overflow-x-auto">
        <table className="data-table w-full">
          <thead>
            {data.length > 0 && (
              <tr>
                {data[0].map((header, i) => (
                  <th key={i} className="text-xs">{header}</th>
                ))}
              </tr>
            )}
          </thead>
          <tbody>
            {data.slice(1).map((row, i) => (
              <tr key={i}>
                {row.map((cell, j) => (
                  <td key={j} className="text-xs">{cell}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ReadOnlySheet;
